<div [style.height]="40"
     [matMenuTriggerFor]="filtersMenu">
  <signaturit-button [text]="'label_filterBy' | translate"
                     type="secondary"
                     size="md"
                     icon="filter_alt">
  </signaturit-button>
</div>
<mat-menu #filtersMenu="matMenu" class="signaturit-table-filters-menu-panel">
  <form [style.width.px]="_options.width"
        (keydown.enter)="onEnterKeyPress($event)"
        class="d-flex flex-column row-gap-2 px-3 py-2"
        (click)="$event.stopPropagation()">
    <h6>{{title}}</h6>
    <ng-container *ngFor="let field of fields">
      <ng-container [ngSwitch]="field.type">

        <!-- SELECT -->
        <ng-container *ngSwitchCase="'select'">
          <div class="flex-grow-1" [ngClass]="{'d-flex flex-row justify-content-between align-items-center': _options.inline}">
            <span class="inline-label description" *ngIf="_options.inline">{{field.label | translate}}</span>
            <signaturit-select #selector [labelName]="_options.inline ? null : field.label | translate"
                               [data]="field.options"
                               [disabled]="field.options?.length === 0"
                               [placeholder]="field.placeholder | translate"
                               [dataValue]="field.labelOption"
                               [dataKey]="field.valueOption"
                               [selectedValue]="field.selectedOption"
                               [width]="228"
                               (selectOption)="onSelectOption($event.value, field.name)">
            </signaturit-select>
          </div>
        </ng-container>

        <!-- DATE -->
        <ng-container *ngSwitchCase="'date'">
          <div class="flex-grow-1" [ngClass]="{'d-flex flex-row justify-content-between align-items-center': _options.inline}">
            <span class="inline-label description" *ngIf="_options.inline">{{field.label | translate}}</span>
            <signaturit-datepicker [label]="_options.inline ? null : (field.label | translate)"
                                   [placeholder]="field.placeholder | translate"
                                   [(value)]="tableFiltersForm[field.name]"
                                   (valueRangeChangeTemplate)="getDateRange($event, field.name)"
                                   [range]="field?.range"
                                   [events]="eventsSubject?.asObservable()">
            </signaturit-datepicker>
          </div>
        </ng-container>

        <!-- TEXT | NUMBER -->
        <div *ngSwitchDefault>
          <div class="flex-grow-1" [ngClass]="{'d-flex flex-row justify-content-between align-items-center': _options.inline}">
            <span class="inline-label description" *ngIf="_options.inline">{{field.label | translate}}</span>
            <signaturit-input [labelName]="_options.inline ? null : (field.label | translate)"
                              [inputType]="field.type"
                              [validationType]="field.type"
                              [(inputValue)]="tableFiltersForm[field.name]"
                              [isRequired]="field.required"
                              [placeholderName]="field.placeholder | translate"
                              [inputWidth]="_options.inline ? 228 : null"
                              (outputValue)="tableFiltersForm[field.name] = $event">
            </signaturit-input>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <div class="d-flex justify-content-end gap-2 mt-2">
      <signaturit-button [text]="'transaction-detail.historical-evidence.clean' | translate"
                         type="tertiary"
                         size="md"
                         (click)="clear()">
      </signaturit-button>
      <signaturit-button [text]="'transaction-detail.historical-evidence.apply' | translate"
                         type="secondary"
                         size="md"
                         (click)="apply()">
      </signaturit-button>
    </div>
  </form>
</mat-menu>
